export default class OfferCampaignBasicInfos {
  constructor($scope, OfferService, OfferCampaignService, UiService, EmailService) {
    $scope.save = function() {
      $scope.saving = true;
      OfferService.save_offer_campaign_settings(window.offer_id, $scope.settings)
        .success(function(data) {
          if (data.success)
            $scope.saving = false;
        });
    };

    $scope.copy_fields = function() {
      $scope.copying_fields = true;
      OfferService.copy_text_fields($scope.similar_campaign_id, window.offer_id).success(function(data) {
        if (data.success) {
          location.reload();
        }
      });
    };

    $scope.init = function() {
      $scope.tinymceOptions = UiService.tinymceOptions();
      $scope.settings = window.campaign_settings || OfferCampaignService.get_default_settings(window.offer_title);
      $scope.settings = OfferCampaignService.set_default_settings($scope.settings);
      $scope.currency_symbols = window.currency_symbols;
      $scope.sender_names = EmailService.get_sender_names_en();
      $scope.sender_names_el = EmailService.get_sender_names_el();
      $scope.similar_campaigns = window.similar_campaigns;
      if ($scope.similar_campaigns.length > 0) {
        $scope.similar_campaign_id = $scope.similar_campaigns[0].id;
      }
    };

    $scope.init();
  }
}

OfferCampaignBasicInfos.$inject = ['$scope', 'OfferService', 'OfferCampaignService', 'UiService', 'EmailService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-basic-infos.ctrl.js